export function getSurveysListingPath(): string {
  return '/jobs/';
}

export function getSurveyPath(key: string): string {
  return `/job/${key}`;
}

export function isSurveyDetailsPath(path: string): boolean {
  return path.startsWith('/job/');
}
